// extracted by mini-css-extract-plugin
export var wordContainer = "_sj-0";